import { Component, OnInit, SimpleChanges } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { config } from "../../../../../environments/config";
import { calendarES } from "../../../../theme/functions/calendarES";
import { Message, LazyLoadEvent } from "primeng/primeng";
import { ActivatedRoute } from "@angular/router";
import { HasPermissionService } from "../../service/has-permission/has-permission.service";
import { Vacation } from "../../class/vacation";
import { VacationService } from "../../service/vacation/vacation.service";
import { TranslateService } from "@ngx-translate/core";
//import { NotificationsService } from "../../../../theme/services/notifications/notifications.service";

@Component({
  selector: "app-vacations",
  templateUrl: "./vacations.component.html",
  styleUrls: ["./vacations.component.scss"],
})
export class VacationsComponent implements OnInit {
  public promiseForm: Promise<any>;
  public msgs: Message[] = [];
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public requestData: any[];
  public requestVacation: any[];
  public sort: string;
  public query: string;
  public loading: boolean = true;
  public es: any;
  public showFilter: boolean;
  public apiUrl = config.API_ROOT;
  public contract_id: { key: string; value: number };
  public myEmployeeId: string;
  public modExportDialog: boolean = false;
  public filters: { key: string; value: string }[];
  public first = 0;
  public current_date: Date;
  public form_export: FormGroup;
  public form_filter: FormGroup;
  public modNew = false;
  //public form_edit_vacations: FormGroup;
  //public form_new_vacations: FormGroup;
  //public modVacationsDialog: boolean = false;
  // public edit: Vacation;
  //public modView = false;
  // public myEmployeeName: string;
  // public created_by_id: any = null;
  // private id: number;
  //public start_contract: number;
  //public company_id: number;
  //public candidate_id: number;
  //public venue_id: number;

  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    public activatedRoute: ActivatedRoute,
    public hasPermissionService: HasPermissionService,
    public vacationService: VacationService,
    public translate: TranslateService
    //private notificationsService: NotificationsService,
  ) {
    this.es = calendarES();
  }

  ngOnInit() {
    this.page = 1;
    this.per_page = 20;
    this.sort = "-id";
    this.current_date = new Date();
    this.filters = [];
    this.contract_id = null;
    this.showFilter = true;
    this.myEmployeeId = JSON.parse(localStorage.getItem("profile")).employee.id;

    this.CreateFilterForm(null);
    this.CreateExportForm(null);
  }
  ngOnChanges(changes: SimpleChanges): void {}

  CreateFilterForm(data: any = null) {
    data = data || {
      candidate_id_filter: null,
      venue_filter: "",
      company_id_filter: "all",
      department_id_filter: "",
    };

    this.form_filter = this.fb.group({
      candidate_id_filter: [data.candidate_id_filter, [Validators.required]],
      venue_filter: [data.venue_filter],
      company_id_filter: [data.company_id_filter],
      department_id_filter: [data.department_id_filter],
    });
  }

  CreateExportForm(data: any = null) {
    data = data || {
      report_type_export: "",
      start_export_date: "",
      end_export_date: "",
      candidate_id_export: "",
      venu_export: "",
      company_id_export: "",
    };

    this.form_export = this.fb.group({
      report_type_export: [data.report_type_export, [Validators.required]],
      start_export_date: [data.start_export_date, [Validators.required]],
      end_export_date: [data.end_export_date, [Validators.required]],
      candidate_id_export: [data.candidate_id_export, [Validators.required]],
      venue_export: [data.venue_export, [Validators.required]],
      company_id_export: [data.company_id_export, [Validators.required]],
    });
  }

  public loadVacationsLazy(event: LazyLoadEvent) {
    this.page = event.first / this.per_page + 1;

    if (event.sortOrder === -1) this.sort = "-" + event.sortField;
    else this.sort = event.sortField;

    if (event.globalFilter) this.query = event.globalFilter;
    else this.query = undefined;

    this.sort = "-id";

    this.getVacations();
  }

  public filter(values?) {
    this.page = 1;
    this.first = 0;
    this.filters = [];

    if (
      values.candidate_id_filter !== null &&
      values.candidate_id_filter !== "" &&
      values.candidate_id_filter !== undefined
    )
      this.filters.push({
        key: "candidate_id",
        value: values.candidate_id_filter.id,
      });

    if (
      values.venue_filter !== null &&
      values.venue_filter !== "" &&
      values.venue_filter !== undefined
    )
      this.filters.push({ key: "venue_id", value: values.venue_filter });

    if (
      values.company_id_filter !== null &&
      values.company_id_filter !== "" &&
      values.company_id_filter !== undefined
    )
      this.filters.push({
        key: "company_id",
        value: values.company_id_filter.id,
      });

    if (
      values.department_id_filter !== null &&
      values.department_id_filter !== "" &&
      values.department_id_filter !== undefined
    )
      this.filters.push({
        key: "department_id",
        value: values.department_id_filter,
      });

    this.getVacations();
  }

  public getVacations() {
    this.loading = true;
    this.vacationService
      .getVacations(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters
      )
      .toPromise()
      .then(
        (response) => {
          this.loading = false;
          this.requestData = response.json().data;

          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords = response.json().meta.total_filtered;
          else this.totalRecords = response.json().meta.total;
        },
        (error) => {
          this.loading = false;
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public getVacation(contract_id: any) {
    this.loading = true;
    this.vacationService
      .getVacation(contract_id)
      .toPromise()
      .then(
        (response: any) => {
          this.loading = false;
          this.requestVacation = JSON.parse(response._body);
          console.log(this.requestVacation);
          this.requestVacation;
        },
        (error) => {
          this.loading = false;
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public hasRole(rol) {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem("profile")).roles[0].id;
    if (role == rol) r = true;

    return r;
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.form_export.reset();
    this.modExportDialog = false;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/vacations/vacations.component.ts